<template>
  <div>
    <v-card>
      <v-card-text>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="lotes.data"
          item-key="id_auto"
          hide-default-footer
          :items-per-page="50"
        >
          <template v-slot:body="{ items }">
            <tbody v-for="item in items" :key="item.id">
                  <tr class="text-left">
                    <td>{{ item.numero_remessa }}</td>
                    <td>{{ item.quantidade_registros_validos }}</td>
                    <td >{{ item.quantidade_registros_invalidos }}</td>
                    <td >{{ item.operadora }}</td>
                    <td >{{ item.nome_agente }}</td>
                    <td>{{ item.data_disponibilizacao | data }}</td>
                    <td >{{ item.total }}</td>
                    <td>{{item.quantidade_registros_confirmados}}</td>
                    <td>{{item.quantidade_registros_cadastrados}}</td>
                  </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <paginate-component
          :pagination="lotes"
          @paginate="pagination($event)"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>

import PaginateComponent from "@/components/Paginate";

export default {
  name: "TabelaLostesInfracao",
  props: {
    lotes: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PaginateComponent,
  },
  data() {
    return {
      headers: [
        { text: "Numero do Lote", value: "numero_remessa" },
        { text: "validas", value: "quantidade_registros_validos"},
        { text: "invalidas", value: "quantidade_registros_invalidos"},
        { text: "Operadora" , value:"operadora"},
        { text: "Nome do Agente", value: "nome_agente" },
        { text: "Data de insercao", value: "created_at" },
        { text: "Total" , value:"total"},
        { text: "Total de registros de imagens analisadas", value: "quantidade_registros_confirmados" },
        { text: "Total de registros de imagens por operadoras", value: "quantidade_registros_cadastrados"},
      ],
    };
  },
  watch: {
    selected(newVal) {
      this.$emit("selected", [...newVal]);
    },
  },
  methods:{
    getColor(status) {
      if (status == 1) return "green";
      else if (status == 2) return "red";
      else if (status == 3) return "yellow";
    },
    pagination(event) {
      this.$emit("input", event);
    }
  },
};
</script>
